export function defineServiceConfigProvider(initialConfig) {
    return {
        id: "service-config-provider",
        create: () => {
            const { configs } = initialConfig;
            const configProvider = {
                configs
            };
            return {
                "1.0.0": () => ({
                    featureService: configProvider
                })
            };
        }
    };
}
